import { render, staticRenderFns } from "./CompraDiretaEmHomologacao.vue?vue&type=template&id=eabdae90"
import script from "./CompraDiretaEmHomologacao.vue?vue&type=script&lang=js"
export * from "./CompraDiretaEmHomologacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports